// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";

var defaultAnchorPosition = [
  0,
  0
];

function make_props(position, clickableOpt, visibleOpt, zIndexOpt, iconOpt, anchorOpt, opacityOpt, onMouseOver, onMouseOut, onClick, onPositionChanged, ref, param) {
  var clickable = clickableOpt !== undefined ? Caml_option.valFromOption(clickableOpt) : false;
  var visible = visibleOpt !== undefined ? Caml_option.valFromOption(visibleOpt) : true;
  var zIndex = zIndexOpt !== undefined ? Caml_option.valFromOption(zIndexOpt) : undefined;
  var icon = iconOpt !== undefined ? Caml_option.valFromOption(iconOpt) : undefined;
  var anchor = anchorOpt !== undefined ? Caml_option.valFromOption(anchorOpt) : defaultAnchorPosition;
  var opacity = opacityOpt !== undefined ? Caml_option.valFromOption(opacityOpt) : 1.0;
  return {
          position: position,
          clickable: clickable,
          visible: visible,
          zIndex: zIndex,
          icon: icon,
          anchor: anchor,
          opacity: opacity,
          onMouseOver: onMouseOver,
          onMouseOut: onMouseOut,
          onClick: onClick,
          onPositionChanged: onPositionChanged,
          ref: ref
        };
}

var defaultOpacity = 1.0;

var defaultClickableStatus = false;

var defaultVisibileStaus = true;

export {
  defaultOpacity ,
  defaultAnchorPosition ,
  defaultClickableStatus ,
  defaultVisibileStaus ,
  make_props ,
  
}
/* No side effect */
